import { Chevron, PopoverButton, ThemeProp } from '@trarc/pc-shared';
import styled from 'styled-components';

import { DetailsActionMenuProps } from './ActionMenu';

interface TriggerProps {
  $isOpen: boolean;
}

export const ActionMenuTriggerContainer = styled.div<TriggerProps>`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.blackLowOpacity};
  background-color: ${({ $isOpen, theme }: ThemeProp & TriggerProps) =>
    $isOpen ? theme.colors.blackLowOpacity : theme.colors.white};
  min-height: inherit;
`;

export const ActionMenuTriggerIcon = styled(Chevron)<TriggerProps>`
  stroke: ${({ theme }: ThemeProp) => theme.colors.black};
  transition: all ease-out 0.15s;
  transform: rotate(${(props: TriggerProps) => (props.$isOpen ? 180 : 0)}deg);
`;

export const ActionMenuTriggerLabel = styled.span``;

export const ActionMenuRow = styled.button`
  background: none;
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.25rem;
  justify-content: flex-start;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 0.25rem;
  color: ${(props: ThemeProp) => props.theme.colors.black};

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.primary}0f;
  }
  &:focus-visible {
    outline: 1px auto ${(props: ThemeProp) => props.theme.colors.primary};
  }
  &:disabled {
    cursor: default;
    opacity: 0.2;
    background: none;
  }
`;

export const StyledPopoverButton = styled(PopoverButton)<DetailsActionMenuProps>`
  min-height: inherit;
  color: ${({ disabled, theme }: DetailsActionMenuProps & ThemeProp) => (disabled ? theme.colors.c400 : undefined)};
  pointer-events: ${({ disabled }: DetailsActionMenuProps) => (disabled ? 'none' : undefined)};
  cursor: ${({ disabled }: DetailsActionMenuProps) => (disabled ? 'not-allowed' : 'pointer')};

  * {
    stroke: ${({ disabled, theme }: DetailsActionMenuProps & ThemeProp) => (disabled ? theme.colors.c400 : undefined)};
  }
  button {
    min-height: inherit;
  }
`;
